import React, { useState } from 'react';
import { Button, CardBody, CardHeader, Heading, Text, useDisclosure, VStack, } from '@chakra-ui/react';
import InspectionDetailCard from '../InspectionDetailCard';
import { useTokens } from '../../../../../context/TokenProvider';
import { localise } from '../../../../../services/lang/lang';
import { UnsavedChangesProvider } from '../../../../modules/UnsavedChanges/UnsavedChangesProvider';
import TenantReportsInviteCountChip from './TenantReportsInviteCountChip';
import RemoteSubmissionInvitesModal from '../../../../modules/RemoteSubmissions/RemoteSubmissionInvitesModal';
import { ModalErrorProvider } from '../../../../modules/Modal/ModalErrorProvider';
import { RenderIf } from '../../../../modules/RenderIf/RenderIf';
const TenantReportsCallToAction = ({ inspection, canEditInspection, }) => {
    const tokens = useTokens();
    const [invitesTabActive, setInvitesTabActive] = useState(false);
    const remoteSubmissionsModal = useDisclosure();
    const handleOnClick = (invitesTabIsActive) => {
        setInvitesTabActive(invitesTabIsActive);
        remoteSubmissionsModal.onOpen();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(InspectionDetailCard, { "data-testid": "tenant_reports_call_to_action" },
            React.createElement(CardHeader, { pl: tokens.Spacing05 },
                React.createElement(Heading, { as: "h2", variant: "lt-500-lt-5" }, localise('TENANT_REPORTS'))),
            React.createElement(CardBody, { p: 0, px: tokens.Spacing05, pb: tokens.Spacing07 },
                React.createElement(VStack, { align: "start", gap: tokens.Spacing05 },
                    React.createElement(Text, { variant: "md-600-rg-4" }, localise('TENANT_REPORTS_DESCRIPTION')),
                    React.createElement(TenantReportsInviteCountChip, { inspectionId: inspection.id, onClickChip: () => handleOnClick(true) }),
                    React.createElement(Button, { "data-testid": "tenant_reports_call_to_action__button", w: "full", variant: "primary", onClick: () => handleOnClick(false) },
                        React.createElement(Text, { variant: "wt-100-md-3" }, localise('TENANT_REPORTS_SEND_INVITATION')))))),
        React.createElement(RenderIf, { condition: remoteSubmissionsModal.isOpen },
            React.createElement(UnsavedChangesProvider, null,
                React.createElement(ModalErrorProvider, null,
                    React.createElement(RemoteSubmissionInvitesModal, { isOpen: true, canEditInspection: canEditInspection, selectedTab: invitesTabActive ? 1 : 0, onClose: remoteSubmissionsModal.onClose, inspection: inspection }))))));
};
export default TenantReportsCallToAction;
